// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bs_d4";
export var AuthorBioContainer = "bs_d2";
export var AuthorBreadcrumbsContainer = "bs_d1";
export var AuthorContainer = "bs_d0";
export var AuthorGradientBackground = "bs_d3";
export var AuthorInfoContainer = "bs_d5";
export var AuthorInfoDetails = "bs_d6";
export var AuthorInfoName = "bs_d7";
export var AuthorInfoSection = "bs_d8";
export var MuiPopperRoot = "bs_bz";
export var MuiTooltipPopper = "bs_bB";
export var qlTooltipLimited = "bs_bC";
export var wpBlockList = "bs_bD";